// Import necessary dependencies
import { useState, useEffect } from "react";
import "./radarChartComponent.scss";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

interface DataSet {
  dataset: {
    option: string;
    count: number;
    percent: number;
  }[];
  color: string;
}

// function hexToRgb(hex: string) {
//   // Remove the leading '#' if present
//   hex = hex.replace(/^#/, "");

//   // Parse the hex string depending on its length
//   let bigint;
//   if (hex.length === 3) {
//     bigint = parseInt(hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2], 16);
//   } else {
//     bigint = parseInt(hex, 16);
//   }

//   // Extract the RGB values
//   const r = (bigint >> 16) & 255;
//   const g = (bigint >> 8) & 255;
//   const b = bigint & 255;

//   return `rgb(${r}, ${g}, ${b}, 0.3)`;
// }

const RadarChartComponent = ({ dataset, color }: DataSet) => {
  const [data, setData] =
    useState<{ option: string; count: number; percent: number }[]>(dataset);

  useEffect(() => {
    if (dataset.length > 0) {
      setData(dataset);
    }
    // eslint-disable-next-line
  }, [dataset]);

  return (
    <div className="radarChartComponent">
      <div className="chartHeader">
        <span className="header">Compliance to requirements</span>
        <span className="subheader">
          Percentage of questions answered with "Yes" in each section
        </span>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="75%" data={data}>
          <PolarGrid />
          <PolarAngleAxis
            dataKey="option"
            style={{
              fontSize: 11,
            }}
          />
          <PolarRadiusAxis
            tick={false} // Hides the radial value counts
            axisLine={false} // Optionally hides the radial axis line
          />
          <Radar
            name="Mike"
            dataKey="percent"
            stroke={color}
            fill={"#ffffff"}
            fillOpacity={0.1}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarChartComponent;
